import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from '@material-ui/core';
import { MagicAiIcon, palette, Typography } from '@dev/ee-components';
import { links } from '@/services/dictionaries/links';
import AITextToolIcon from '@/services/icons/ai-text-tool-icon.svg';

import { CheckWithText } from './CheckSection';
import { AIIconWrapper, Title } from './styles';

export const AITextToolModalBody = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant={'body1'} bodyVariant={'onPaper'}>
                {`${t('aitexttoolmodal_desc')} `}
                {
                    <Link target="_blank" rel="noreferrer" href={links.aiTextTool}>
                        {t('readmorehere')}
                    </Link>
                }
            </Typography>
            <Title>
                <Typography variant="h4">{t('howitworks')}</Typography>
            </Title>
            <CheckWithText marginBottom={16}>
                <>
                    {t('clickinicon')}
                    <AIIconWrapper>
                        <MagicAiIcon color={palette.snow[1]} width={16} height={16} />
                    </AIIconWrapper>
                    {t('aitexttool_instruction1')}
                </>
            </CheckWithText>
            <AITextToolIcon />
            <CheckWithText>{t('aitexttool_instruction2')}</CheckWithText>
            <CheckWithText>{t('aitexttool_instruction3')}</CheckWithText>
            <CheckWithText>{t('aitexttool_instruction4')}</CheckWithText>
        </>
    );
};
